interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: {
    label: string;
    path: string;
  };
}

export default function SectionHeader({ title, subtitle, action }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between mb-6">
      <div>
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
        )}
      </div>
      {action && (
        <a
          href={action.path}
          className="flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
        >
          {action.label}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
        </a>
      )}
    </div>
  );
}